<script>
import baseEdit from '@/views/components/base/baseEdit.vue'
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: 'offices',
      key: 'id',
      url: {
        get: '/admin/system/desk',
        add: '/admin/system/desk',
        edit: '/admin/system/desk',
      },
      items: [
        { label: '基本信息', desc: '表单的基本信息', type: 'header' },
        { label: '科室名称', name: 'deskName', value: '', type: 'input',width:'400px', rules: [{ required: true, trigger: 'blur' }] },
        { label: '楼宇楼层', name: 'address', value: '', type: 'input',width:'400px', rules: [{ required: true, trigger: 'blur' }] },
      ],
      forms: {},
    }
  },
  created() {
  },
  methods: {
  
  },
}
</script>
